"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddNewLinkComponent = void 0;
var React = require("react");
var pp_react_1 = require("@paypalcorp/pp-react");
var manage_generic_component_1 = require("./manage-generic.component");
function AddNewLinkComponent(_a) {
    var type = _a.type, content = _a.content, fpti = _a.fpti, props = _a.props, objTobeRendered = _a.objTobeRendered, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (React.createElement(pp_react_1.Link, { "data-name": fpti.addNew, href: "/", className: className || '', onClick: function (e) { return manage_generic_component_1.handleAdd(type, props, objTobeRendered, e); } },
        React.createElement(pp_react_1.Icon, { name: "add", size: "sm" }),
        content.manageAdd.link));
}
exports.AddNewLinkComponent = AddNewLinkComponent;
